import PropTypes from "prop-types";

export const jobCartFeatureInterface = {
  dbFeatureId: PropTypes.number, // 173574953
  featureDefinitionID: PropTypes.number, // 10297004
  partId: PropTypes.string, // "vanity_countertop"
  partName: PropTypes.string, // "Concrete Dark"
  sharedFeatureName: PropTypes.string, // "Rugged Concrete 1 Caesarstone"
  sku: PropTypes.string, // "PC3P02L20J"
  groupName: PropTypes.string, // "Fridge"
  parentName: PropTypes.string, // "Custom Fridge"
}

export const jobCartItemInterface = {
  addedBy: PropTypes.string, // "user", "auto"
  cartFeature: PropTypes.shape(jobCartFeatureInterface).isRequired,
  currentQuote: PropTypes.number, // 0
  displayFakeFeatureGroupName: PropTypes.string, // null
  displayFakeQuantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // null
  fromVisualizerType: PropTypes.string, // "bvLook"
  id: PropTypes.string.isRequired, // "22c74260-b10a-4157-971f-4c441565bcd8"
  parentKey: PropTypes.string, // "vanity_countertop"
  partId: PropTypes.string, // "vanity_countertop"
  qtCatName: PropTypes.string, // "Bathroom"
  quantity: PropTypes.number, // 9.26
  selectionGroup: PropTypes.string, // "Countertop" // not used
  shouldUseRelatedParentFeatureAsMain: PropTypes.bool, // false
  sqftId: PropTypes.number, // 1
  sqftIds: PropTypes.array, // [1, 2]
  sqftQuantities: PropTypes.object, // {1: 4.63, 2: 4.63}
  unit: PropTypes.string, // "m2" // todo
  noteText: PropTypes.string, // ""
  calculatedCost: PropTypes.number, // 22.33 // todo

  itemCurrency: PropTypes.string, // todo
  calculatedPrice: PropTypes.string, // todo
}

export const jobEditGroupObjectInterface = {
  id: PropTypes.string,
  groupName: PropTypes.string,
  quoteIndex: PropTypes.number,
  cartItems: PropTypes.arrayOf(PropTypes.shape(jobCartItemInterface)),
}
